import { Map, Marker } from 'mapbox-gl';

export const ACHIEVEMENTS_HIDE_ZOOM = 10;

export const hideMarkerAtZoomLevel = (
  map: Map,
  marker: Marker,
  minZoom = ACHIEVEMENTS_HIDE_ZOOM
): void => {
  map.on('zoom', () => {
    if (map.getZoom() < minZoom) {
      marker.getElement().style.display = 'none';
    } else {
      marker.getElement().style.display = 'block';
    }
  });
};
